import defaultApi from '@/utils/request';

export default {
  // ========================================================================================================
  // S46W2001 就學貸款申請作業
  // 取資料
  S46W2001_CheckRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S46/S46W2001_CheckRecord',
      params,
    });
  },
  S46W2001_BasicViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S46/S46W2001_BasicViewLoad',
      params,
    });
  },
  S46W2001_BasicViewUpdate(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S46/S46W2001_BasicViewUpdate',
      data,
    });
  },
  S46W2001_GetPdfFile(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S46/S46W2001_GetPdfFile',
      responseType: 'blob',
      params,
    });
  },

};
